import { render } from "./PageIntro.vue?vue&type=template&id=93234ee4"
import script from "./PageIntro.vue?vue&type=script&lang=js"
export * from "./PageIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__